


























































import * as R from 'ramda'
import moment from 'moment-timezone'
import { mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { GetterNames } from '@/store/modules/exercise-program/keys'
import { GetterNames as PatientGetterNames } from '@/store/modules/patient/keys'
import { UserActionContexts } from '@/constants/urls'
import ExerciseProgramDetailHead from '@/components/exercise-programs/components/ExerciseProgramDetailHead.vue'
import ExerciseProgramParticipantList from '@/components/exercise-programs/components/ExerciseProgramParticipantList.vue'
import ExerciseProgramExerciseSessionTable from '@/components/exercise-programs/components/ExerciseProgramExerciseSessionTable.vue'

type ComponentData = {
  exerciseProgramSessionDateFilter: string
}

export default {
  components: {
    ExerciseProgramDetailHead,
    ExerciseProgramParticipantList,
    ExerciseProgramExerciseSessionTable,
  },

  data(): ComponentData {
    return {
      exerciseProgramSessionDateFilter: '',
    }
  },

  computed: {
    newExerciseSessionRouteContext() {
      return UserActionContexts.New
    },
    newExerciseSessionRouteParams() {
      return {
        name: 'new-exercise-session',
        params: {
          program_id: this.exerciseProgramId,
          context: this.newExerciseSessionRouteContext,
        },
      }
    },
    exerciseProgramParticipants() {
      return this[PatientGetterNames.patients].filter(patient =>
        this.exerciseProgram.participants.find(participant => participant === patient.id)
      )
    },
    exerciseProgram() {
      return this[GetterNames.chosenExerciseProgram]
    },
    exerciseProgramId() {
      return this[GetterNames.chosenExerciseProgramId]
    },
    exerciseProgramSessions() {
      if (this.exerciseProgram.sessions && !R.isEmpty(this.exerciseProgram.sessions)) {
        return R.sort(this.sortBySessionDate, this.exerciseProgram.sessions)
      } else {
        return []
      }
    },
    hasExerciseProgramSessions() {
      return !R.isEmpty(this.exerciseProgramSessions)
    },
    lastExerciseSessionDate() {
      if (this.hasExerciseProgramSessions) {
        return this.exerciseProgramSessions[0].date
      } else {
        return null
      }
    },
    exerciseProgramSessionsFilteredByDate() {
      if (this.exerciseProgramSessionDateFilter) {
        return this.exerciseProgramSessions.filter(session =>
          this.exerciseProgramSessionDateFilter.includes(session.date)
        )
      }
      return this.exerciseProgramSessions
    },
    exerciseProgramSessionDates() {
      const sessionDates = [{ name: 'All', value: '' }]
      const allDates = this.exerciseProgramSessions.map(session => session.date)
      allDates.forEach(date => {
        if (sessionDates.indexOf(date) === -1) {
          sessionDates.push({
            name: moment(date).format('DD MMMM YYYY'),
            value: date,
          })
        }
      })
      return sessionDates
    },
    ...mapGetters(ModuleNames.exerciseProgram, [
      GetterNames.chosenExerciseProgram,
      GetterNames.chosenExerciseProgramSessions,
      GetterNames.chosenExerciseProgramId,
    ]),
    ...mapGetters(ModuleNames.patient, [PatientGetterNames.patients]),
  },

  watch: {
    exerciseProgramId() {
      this.exerciseProgramSessionDateFilter = this.exerciseProgramSessionDates.map(date => date.value)
    },
  },

  methods: {
    editExerciseProgramAction() {
      this.$emit('editExerciseProgramAction')
    },
    deleteExerciseProgramAction(e) {
      this.$emit('deleteExerciseProgramAction', e)
    },
    deleteExerciseSessionAction(e) {
      this.$emit('deleteExerciseSessionAction', e)
    },
    sortBySessionDate(a, b) {
      if (a.date < b.date) {
        return 1
      } else if (a.date > b.date) {
        return -1
      }
      return 0
    },
  },
}
